import { useTranslation } from "react-i18next";
import { useAxios } from "../useAxios";
import { useQuery } from "@tanstack/react-query";
import { LevelDOverallStatistics, LevelDReportFilter } from "../../types/leveld-reports";

export const useGetLevelDStatistics = (filter: LevelDReportFilter, enabled = true) => {
    const axios = useAxios();
    const { t } = useTranslation();

    const fetchStatistics = async (): Promise<LevelDOverallStatistics> => {
        try {
            const params = new URLSearchParams({
                startDate: filter.startDate,
                endDate: filter.endDate,
            });
            
            if (filter.examTermId) {
                params.append('examTermId', filter.examTermId);
            }
            if (filter.examId) {
                params.append('examId', filter.examId);
            }

            const { data } = await axios.get(`/api/leveldreports/statistics?${params.toString()}`);
            return data;
        } catch (error) {
            throw new Error(t("levelDReports.errors.getStatistics"));
        }
    };

    return useQuery({
        queryKey: ["levelDStatistics", filter],
        queryFn: fetchStatistics,
        enabled: enabled && Boolean(filter.startDate) && Boolean(filter.endDate),
    });
};
